import { Alert, AlertTitle, Box, Button } from '@mui/material'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

export default function ErrorBoundary() {
  const error = useRouteError()

  let errorMessage = 'An unexpected error occurred'

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data?.message || 'Page not found'
  } else if (error instanceof Error) {
    errorMessage = error.message
  } else if (typeof error === 'string') {
    errorMessage = error
  }

  return (
    <Box sx={{ p: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Alert severity='error' sx={{ mb: 2 }}>
        <AlertTitle>Something went wrong</AlertTitle>
        {errorMessage}
      </Alert>
      <Button
        variant='contained'
        onClick={() => window.location.reload()}
        sx={{ mr: 2 }}
      >
        Try Again
      </Button>
      <Button variant='outlined' onClick={() => window.history.back()}>
        Go Back
      </Button>
    </Box>
  )
}
